import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Checkbox, Typography, WithInfoIcon } from 'seagull';
import styles from '../ServiceAdvancedSettings.module.scss';
export function AdvancedSettingsControl(props) {
    const { info, infoTestId, checked, testId, label, disabledTooltip, disabled, children, labelSuffix, isReadOnly, onChange, bi } = props;
    const hasCompactGap = !label && !!labelSuffix;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.container, {
                    [styles.compactGap]: hasCompactGap
                }),
                children: [
                    /*#__PURE__*/ _jsxs(WithInfoIcon, {
                        info: info,
                        showInfo: !!info,
                        infoTestId: infoTestId,
                        children: [
                            /*#__PURE__*/ _jsx(Checkbox, {
                                checked: checked,
                                disabled: disabled || isReadOnly,
                                tooltip: !isReadOnly && disabled && disabledTooltip ? {
                                    placement: 'top',
                                    title: /*#__PURE__*/ _jsx("div", {
                                        "data-testid": testId && "".concat(testId, "-disabled-tooltip"),
                                        children: disabledTooltip
                                    })
                                } : undefined,
                                testId: testId,
                                onChange: (e)=>onChange(e.target.checked),
                                bi: bi
                            }),
                            label && /*#__PURE__*/ _jsx(Typography, {
                                skin: disabled && !isReadOnly ? 'disabled' : 'standard',
                                children: label
                            })
                        ]
                    }),
                    labelSuffix
                ]
            }),
            children
        ]
    });
}
